import { sha256 } from 'js-sha256';
import { Move } from './models/move';

export class MoveListSerializer {
  public static getHash(moveList: Move[]): string {
    const output = MoveListSerializer.serializedCommands(moveList);
    return MoveListSerializer.computeHash(output);
  }

  public static serializedCommands(moveList: Move[]): string {
    return moveList.map((move) => move.serializeToString()).join('\n');
  }

  public static computeHash(output: string): string {
    return sha256.create().update(output).hex();
  }
}
